import React from "react"
import Sticky from "react-stickynode"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import ResetCSS from "@/common/assets/css/style"
import { AppWrapper } from "@/containers/common/style"

import MetaData from "@/common/components/MetaData"
import NavbarNew from "@/containers/common/NavbarNew"
import Footer from "@/containers/common/FooterNew"
import Heading from "@/common/components/_UI/Heading"
import SectionLine from "@/common/components/SectionLine"
import GlowBox from "@/common/components/GlowBox"
import Button from "@/common/components/Button"
import JoinUsSection from "@/containers/JoinUs/JoinUsSection"
import OurValue from "@/containers/JoinUs/OurValue"
import WhyWorkHere from "@/containers/JoinUs/WhyWorkHere"
import LaserBg from "@/containers/JoinUs/LaserBg"
import Benefits from "@/containers/JoinUs/Benefits"
import TypeText from "@/containers/JoinUs/TypeText"

const JoinUs = () => {
  const { t } = useTranslation("joinUs")

  return (
    <div>
      <>
        <MetaData
          title={t("meta.title")}
          description={t("meta.description")}
          url={t("meta.url")}
          image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
          languageAlternates={[
            [
              {
                hrefLang: "en-US",
                href: "https://www.kryptogo.com/join-us"
              },
              {
                hrefLang: "zh-TW",
                href: "https://www.kryptogo.com/tw/join-us"
              },
              {
                hrefLang: "zh-CN",
                href: "https://www.kryptogo.com/cn/join-us"
              }
            ]
          ]}
        />

        <ResetCSS />
        {/* end of global and reset style */}

        {/* start app classic landing */}
        <AppWrapper>
          <Sticky top={0} innerZ={1000} activeClass="sticky-active">
            <NavbarNew />
          </Sticky>
          <BGWrapper>
            <GlowBox />
          </BGWrapper>

          <ContainerWrapper>
            <BannerWrapper>
              <LaserBg />
              <TitleWrapper>
                <Heading content={t("joinUs.title")} center />
                <TypeText />
                <Heading content={t("joinUs.desc2")} center />
                <div className="buttonGroup">
                  <Button href="#opening" title={t("joinUs.btn")} />
                  <Button
                    herf="#whyus"
                    type="secondary"
                    title={t("joinUs.btn1")}
                  />
                </div>
              </TitleWrapper>
            </BannerWrapper>

            <SectionLine />
            <WhyWorkHere />
            <SectionLine />
            <OurValue />
            <SectionLine />
            <JoinUsSection />
            <SectionLine />
            <Benefits />
            <SectionLine />
          </ContainerWrapper>

          <Footer />
        </AppWrapper>
      </>
    </div>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, ["joinUs", "contactUs", "common"]))
  }
})

export default JoinUs

const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100;
  overflow: hidden;
`

const BannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  min-height: 768px;
  position: relative;
`

const TitleWrapper = styled.div`
  padding: 0 20px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  .typetext {
    margin: -24px 0 15px 0;
  }
  h2 {
    margin: 0;
    text-align: center;
  }

  .mission {
    max-width: 800px;
    line-height: 1.8;
    font-weight: 700;
    font-size: 32px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    word-wrap: break-word;
    span {
      color: ${themeGet("colors.secondary")};
      font-weight: 700;
      background: ${themeGet("colors.primary")};
      padding-left: 12px;
      padding-right: 12px;
      margin-right: 12px;
      margin-left: 12px;
    }
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
  .center {
    margin-left: auto;
    margin-right: auto;
  }
  .buttonGroup {
    width: 100%;
    margin-top: 52px;
    display: flex;
    justify-content: center;
    gap: 2rem;
    @media (max-width: 510px) {
      flex-direction: column;
      gap: 15px;
      text-align: center;
    }
  }
`
const BGWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
`
